export default (link) => {
  return new URL(link).hostname;
};
